module.exports = __webpack_public_path__ + "static/img/cus-service-kaka.0d05e020.png";